/* Emballage cadeau — logique panier (page /cart).
   - Affiche/masque la bannière selon la liste d'exclusion SKU (géré aussi côté serveur).
   - Coche = ajoute la variante gift-wrap ; décoche = retire.
   - Quantité d'emballages = plafond(nb moustiquaires / 6). Moustiquaire = product_type "Moustiquaire*"
     hors pièces détachées (ADH/CLIPS/TRAP). Se resynchronise quand le client change une quantité.
   Détection = par ID variante / SKU GIFT-WRAP. Anti-boucle via flag "busy". */
(function () {
  if (window.__giftWrapInit) return;          // le <script> ré-injecté par un refresh ne réexécute pas la logique
  window.__giftWrapInit = true;

  var GIFT_SKU = 'GIFT-WRAP';

  var EXCL = new Set([
    'STD-70X210-N','STD-80X210-N','STD-90X210-N','STD-100X210-N','STD-110X210-N','STD-120X210-N',
    'STD-70X210-B','STD-80X210-B','STD-90X210-B','STD-100X210-B','STD-110X210-B','STD-120X210-B',
    'ADH-POR-2CM-5M-N','ADH-POR-2CM-10M-N','ADH-POR-2CM-20M-N','ADH-POR-4CM-5M-N','ADH-POR-4CM-10M-N','ADH-POR-4CM-20M-N',
    'ADH-POR-2CM-5M-B','ADH-POR-2CM-10M-B','ADH-POR-2CM-20M-B','ADH-POR-4CM-5M-B','ADH-POR-4CM-10M-B','ADH-POR-4CM-20M-B',
    'CLIPS-STD-N','CLIPS-XL-N','CLIPS-STD-B','CLIPS-XL-B','TRAP-N','TRAP-B'
  ]);
  var SPARE = new Set([
    'ADH-POR-2CM-5M-N','ADH-POR-2CM-10M-N','ADH-POR-2CM-20M-N','ADH-POR-4CM-5M-N','ADH-POR-4CM-10M-N','ADH-POR-4CM-20M-N',
    'ADH-POR-2CM-5M-B','ADH-POR-2CM-10M-B','ADH-POR-2CM-20M-B','ADH-POR-4CM-5M-B','ADH-POR-4CM-10M-B','ADH-POR-4CM-20M-B',
    'CLIPS-STD-N','CLIPS-XL-N','CLIPS-STD-B','CLIPS-XL-B','TRAP-N','TRAP-B'
  ]);

  var busy = false;
  var norm = function (s) { return String(s == null ? '' : s).trim().toUpperCase(); };
  function bannerEl() { return document.getElementById('gift-wrap-banner'); }
  function variantId() { var b = bannerEl(); return b ? parseInt(b.dataset.variantId, 10) : NaN; }

  function getCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }

  function evaluate(cart) {
    var vid = variantId();
    var show = false, nets = 0, gw = null;
    (cart.items || []).forEach(function (it) {
      var sku = norm(it.sku);
      if (sku === GIFT_SKU || it.id === vid || it.variant_id === vid) { gw = it; return; }
      if (!EXCL.has(sku)) show = true;
      var type = it.product_type || '';
      if (type.indexOf('Moustiquaire') === 0 && !SPARE.has(sku)) nets += it.quantity;
    });
    var units = Math.max(1, Math.ceil(nets / 6));
    return { show: show, nets: nets, units: units, gw: gw };
  }

  function tagRow() {
    document.querySelectorAll('.cart-item').forEach(function (tr) {
      // La classe est posée côté Liquid ; fallback : la ligne gift-wrap est la seule à porter la description dédiée
      if (tr.querySelector('.cart-item__gift-wrap-desc')) tr.classList.add('cart-item--gift-wrap');
    });
  }

  function cartApi(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  // Re-render natif des sections panier (items + footer + bulle) sans reload complet.
  function refreshCartUI() {
    return fetch(location.pathname, { headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        ['main-cart-items', 'main-cart-footer', 'cart-icon-bubble'].forEach(function (id) {
          var cur = document.getElementById(id), neu = doc.getElementById(id);
          if (cur && neu) cur.replaceWith(neu);
        });
        tagRow();
      });
  }

  // Aligne l'état réel du panier sur les règles (retrait si non éligible, ajustement des unités).
  function reconcile() {
    if (busy) return Promise.resolve();
    busy = true;
    return getCart().then(function (cart) {
      var e = evaluate(cart), changed = false, p = Promise.resolve();
      // Resynchronise l'affichage (décoche si la ligne a été retirée via la corbeille, etc.)
      var b = bannerEl();
      if (b) {
        b.hidden = !e.show;
        var cb = document.getElementById('gift-wrap-checkbox'); if (cb) cb.checked = !!e.gw;
        var m = b.querySelector('[data-gift-wrap-multi]'); if (m) m.hidden = !(e.units > 1);
      }
      if (e.gw && !e.show) {
        p = cartApi('/cart/change.js', { id: e.gw.key, quantity: 0 }); changed = true;
      } else if (e.gw && e.gw.quantity !== e.units) {
        p = cartApi('/cart/change.js', { id: e.gw.key, quantity: e.units }); changed = true;
      }
      return p.then(function () { return changed ? refreshCartUI() : tagRow(); });
    }).catch(function () {}).then(function () { busy = false; });
  }

  function onToggle(checked) {
    if (busy) return;
    busy = true;
    getCart().then(function (cart) {
      var e = evaluate(cart), p;
      if (checked && !e.gw) {
        p = cartApi('/cart/add.js', { items: [{ id: variantId(), quantity: e.units }] });
      } else if (!checked && e.gw) {
        p = cartApi('/cart/change.js', { id: e.gw.key, quantity: 0 });
      } else {
        p = Promise.resolve();
      }
      return p.then(refreshCartUI);
    }).catch(function () { return refreshCartUI().catch(function () {}); })
      .then(function () { busy = false; });
  }

  // Synchro d'affichage à l'ouverture (checkbox + visibilité + message), sans muter le panier.
  function initSync() {
    return getCart().then(function (cart) {
      var e = evaluate(cart), b = bannerEl();
      if (b) {
        b.hidden = !e.show;
        var cb = document.getElementById('gift-wrap-checkbox'); if (cb) cb.checked = !!e.gw;
        var m = b.querySelector('[data-gift-wrap-multi]'); if (m) m.hidden = !(e.units > 1);
      }
      tagRow();
    }).catch(function () {});
  }

  // Checkbox (délégué → survit aux remplacements de DOM)
  document.addEventListener('change', function (e) {
    if (e.target && e.target.id === 'gift-wrap-checkbox') onToggle(e.target.checked);
  });

  // Changements natifs de quantité → re-render de #main-cart-items → on réconcilie
  function observe() {
    var host = document.querySelector('cart-items') || document.getElementById('main-cart-items');
    if (!host) return;
    var deb;
    new MutationObserver(function () {
      if (busy) return;
      clearTimeout(deb); deb = setTimeout(reconcile, 250);
    }).observe(host, { childList: true, subtree: true });
  }

  function boot() { tagRow(); observe(); initSync().then(reconcile); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
